// extracted by mini-css-extract-plugin
module.exports = {"ScoresPanel":"ScoreGraph_ScoresPanel__-Z240","TableContainer":"ScoreGraph_TableContainer__Ldruo"};